const ApplyNowButton = () => {
    const scrollToHero = () => {
      const heroSection = document.getElementById("hero-section");
      if (heroSection) {
        heroSection.scrollIntoView({ behavior: "smooth" });
      }
    };
  
    return (
      <button className="apply-now-btn" onClick={scrollToHero}>
        APPLY NOW
      </button>
    );
  };
  
  export default ApplyNowButton;
  